<div *ngIf="!data.networkMember" class="dialog-container" [style]="getDialogContainerStyles()">
  <div class="title-bar">
    <div class="title">{{data.title}}</div>
    <mat-progress-spinner *ngIf="working" class="spinner" color="primary" mode="indeterminate" diameter="21">
    </mat-progress-spinner>
  </div>
  <span class="text">{{data.body}}</span>
  <div class="buttons">
    <div *ngIf="data.checkboxText" class="checkbox-container">
      <mat-checkbox class="dialog-button-checkbox" color="primary" [disabled]="working" [(ngModel)]="checked">
        {{data.checkboxText}}
      </mat-checkbox>
    </div>
    <button mat-button class="text-button" *ngFor="let button of data.buttons" [ngClass]="button.class"
      [disabled]="!buttonReady(button)" (click)="handleClick(button.handler)">{{button.text}}</button>
  </div>
</div>
<div *ngIf="data.networkMember" class="dialog-container network-container" [style]="getDialogContainerStyles()">
  <avatar class="avatar" [text]="data.networkMember.fullName" [url]="data.networkMember.photoUrl"></avatar>
  <div class="title">{{data.title}}</div>
  <div class="text">{{data.body}}</div>
  <div class="buttons">
    <div *ngIf="data.checkboxText" class="checkbox-container">
      <mat-checkbox class="dialog-button-checkbox" color="primary" [disabled]="working" [(ngModel)]="checked">
        {{data.checkboxText}}
      </mat-checkbox>
    </div>
    <button mat-button class="text-button" *ngFor="let button of data.buttons" [ngClass]="button.class"
      [disabled]="!buttonReady(button)" (click)="handleClick(button.handler)">
      {{button.text}}
    </button>
  </div>
  <mat-progress-spinner *ngIf="working" class="spinner" color="primary" mode="indeterminate" diameter="21">
  </mat-progress-spinner>
</div>